import type { ReactElement } from 'react';
import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import './progress-bar.scss';

type Props = {
  bar: number;
  triangle: number;
  showTriangle?: boolean;
};

export default function ProgressBar({ bar, triangle, showTriangle }: Props): ReactElement {
  const svgRef = useRef<HTMLDivElement>();

  // Plot chart after JSX rendered
  useEffect(() => {
    const svgElement = d3
      .select(svgRef.current)
      .append('svg')
      .classed('progress-bar-box', true)
      .attr('viewBox', `0 0 100 10`)
      .attr('width', '100%')
      .attr('style', 'border:1px solid black');

    // progress bar fill
    svgElement
      .append('rect')
      .classed('progress-bar-progress', true)
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', `${bar}%`)
      .attr('height', 20);

    // triangle
    if (showTriangle) {
      svgElement
        .append('path')
        .classed('progress-bar-triangle', true)
        .attr('d', d3.symbol().type(d3.symbolTriangle))
        .attr('style', `transform: translate(${triangle}%, 2px) rotate(180deg)`);
    }
    // remove d3 on unmount
    return () => {
      svgElement.remove();
    };
  }, [bar, triangle, showTriangle]);

  return <div className="progress-bar-svg" ref={svgRef} />;
}
